import * as Sentry from '@sentry/browser';

interface AuthorizationData {
  merchantId: string;
  userId: string;
  sessionId: string;
}

export const generateAuthorizationToken = (
  authorisationData: AuthorizationData,
) => {
  const { merchantId, userId, sessionId } = authorisationData;

  if ([merchantId, userId, sessionId].some((param) => !param)) {
    Sentry.captureException(
      new Error('####Not enough data for Pgw Authorization Token####:'),
      {
        extra: {
          location: window.location.href,
        },
      },
    );
  }
  return btoa(`${merchantId}:${userId}:${sessionId}`);
};
